import { resource } from "./resource";
import { invalidateOrgGroups } from "./globalData";

const api = resource("/employee-group");

export const createGroup = async (input = {}) => {
  const res = await api.post("", input);
  if (res?.success !== false) invalidateOrgGroups();
  return res;
};

export const getAllGroups = async () => await api.get();
